.pes-software-modal-header-cell {
  font-size: 14px;
  line-height: 1.7142857143;
  font-weight: bold;
  color: #333333;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .pes-software-modal-header-cell {
    padding-left: 17px;
  }

  :host([dir="rtl"]) .pes-software-modal-header-cell {
    padding-right: 17px;
  }
}

@media screen and (max-width: 719px) {
  .pes-software-modal-header-cell:not(.pes-software-modal-header-cell--first) {
    display: none;
  }
}